import { useState, useEffect } from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import FilterSidebar from '../../components/marketplace/FilterSidebar';
import SellAssetModal from '../../components/marketplace/SellAssetModal';
import SellAccountModal from '../../components/marketplace/SellAccountModal';
import { api } from '../../api/api';

const Marketplace = () => {
  const [activeTab, setActiveTab] = useState('Assets');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [sortOrder, setSortOrder] = useState('');
  const [categories, setCategories] = useState<string[]>([]);
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [isSellModalOpen, setIsSellModalOpen] = useState(false);
  const [userAssets, setUserAssets] = useState<any[]>([]);

  useEffect(() => {
    const fetchCategoriesAndUserAssets = async () => {
      try {
        let fetchedCategories: string[] = [];
        if (activeTab === 'Assets' || activeTab === 'Boosting') {
          const response = await api.get('/api/all/assets');
          fetchedCategories = Array.from(new Set(response.data.map((item: any) => item.category)));
        } else if (activeTab === 'Accounts') {
          const response = await api.get('/api/all/account_sales');
          const gameNames: string[] = Array.from(new Set(response.data.map((item: any): string => String(item.game_name))));
          const leagues: string[] = Array.from(new Set(response.data.map((item: any): string => String(item.league))));
          fetchedCategories = [...gameNames, ...leagues];
        }
        setCategories(fetchedCategories);

        const userAssetsResponse = await api.get('/api/user/assets');
        setUserAssets(userAssetsResponse.data);
      } catch (error) {
        console.error('Failed to fetch categories or user assets', error);
      }
    };
    fetchCategoriesAndUserAssets();
  }, [activeTab]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCategory(e.target.value);
  };

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSortOrder(e.target.value);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setSelectedCategory('');
    setSortOrder('');
  };

  const renderSellModal = () => {
    if (!isSellModalOpen) return null;

    switch (activeTab) {
      case 'Assets':
        return <SellAssetModal isOpen={isSellModalOpen} onClose={() => setIsSellModalOpen(false)} />;
      case 'Accounts':
        return <SellAccountModal isOpen={isSellModalOpen} onClose={() => setIsSellModalOpen(false)} />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full h-full flex flex-col bg-[#00000071]">
      <Header />
      <div
        style={{
          backgroundImage: "url(assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex-grow flex flex-col items-center w-full relative pt-6 px-4"
      >

          {/* Top Section: Search Bar and Sell Button */}

            {/* Content Area */}
            <div className="w-full md:w-3/4 flex items-center justify-center py-[200px]">
                                <h1 className="text-[30px] font-semibold text-white text-center" dangerouslySetInnerHTML={{ __html: 'Our marketplace is currently in development <br /> and will launch soon with secured funding' }}></h1>
            </div>

      </div>
      <Footer />
      {renderSellModal()}
    </div>
  );
};

export default Marketplace;
